import emailRegexp from "../regexp/emailRegexp";

const isEmail = (email: string): boolean => {
  return emailRegexp.test(email);
};

export default isEmail;
